module.exports = __webpack_public_path__ + "static/media/cloud.aa71a065.svg";